export {
  createLocalId, createProcessLog, finalizeProcessLogs,
  parseCollabStatusTag, addCollabStatusToLogs,
  extractProcessLogsFromText, extractAllContentFromText,
  stripThinkingAndToolCallTags,
  getAgentName, getAgentAvatar, getAgentColor, getAgentAvatarInfo, hasAgentProfile, DEFAULT_AVATAR_INFO,
  GENERATION_FEATURE_MAP,
  calculateNewNodePosition,
  formatAgentIdToName,
} from './tagParser';

export {
  restoreBackendMessage,
} from './messageRestore';

export {
  formatDuration, formatSessionDate,
  buildAssistantIntro, formatFinalAssistantText,
  getTaskStatusIcon, getTaskStatusColor, getTaskStatusLabel, getTaskStatusBorderBg,
  isReversePromptRequest,
} from './formatUtils';

export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
      return;
    }
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      const canvas = document.createElement('canvas');
      const MAX_SIZE = 1024;
      let w = img.width;
      let h = img.height;
      if (w > h && w > MAX_SIZE) { h = Math.round(h * MAX_SIZE / w); w = MAX_SIZE; }
      else if (h > MAX_SIZE) { w = Math.round(w * MAX_SIZE / h); h = MAX_SIZE; }
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.onerror = reject;
    img.src = url;
  });
};

export const summarizeTopic = (text: string): string => {
  // 剥离引用前缀后再生成标题
  const cleaned = text
    .replace(/\[用户引用了以下参考素材:[^\]]*\]\s*/g, '')
    .replace(/\[用户上传了附件:[^\]]*\]\s*/g, '')
    .trim();
  if (!cleaned || cleaned.length <= 12) return cleaned || '未命名对话';
  const noPunct = cleaned.replace(/[，。？！,.?!]/g, ' ').trim();
  const words = noPunct.split(/\s+/).filter(Boolean);
  if (words.length <= 4) return cleaned.slice(0, 14);
  const summary = words.slice(0, 5).join('');
  return summary.length > 14 ? summary.slice(0, 12) + '…' : summary;
};
